import React from 'react';
import LinearProgress from '@mui/material/LinearProgress';
import { useSelector } from 'react-redux';

export default function Loading() {
  const { loading } = useSelector((state) => state.feedback);
  return (loading && <LinearProgress color="secondary" />);
}
